(function () {
	'use strict';
	angular
		.module('jcsfApp')
		.controller('forestServiceController', forestServiceController);
	forestServiceController.$inject = [
		'$controller',
		'$rootScope',
		'$scope',
		'$window',
		'events',
		'authService',
		'dataService',
	];
	function forestServiceController(
		$controller,
		$rootScope,
		$scope,
		$window,
		events,
		authService,
		dataService
	) {
		$controller('baseController', { $scope: $scope });
		var vm = this;
		authService.fillAuthData();
		var authentication = authService.authentication;
		vm.baseUrl = '/api/jccenter/';
		vm.projectDocuments = [];

		vm.orderBy = sessionStorage.getItem('forestServiceOrderBy') || 'LastName';
		vm.orderByReverse = false;
		vm.setOrderBy = setOrderBy;
		vm.centers = [];
		vm.hours = [];
		vm.centerId = authService.authentication.userInfo.JCCCC;
		vm.userJCCCC = authService.authentication.userInfo.JCCCC;
		vm.calendarYear = null;
		vm.resourceId = 0;
		vm.boolToStr = function (arg) {
			return arg ? 'Yes' : 'No';
		};
		vm.boolToStr2 = function (arg) {
			return arg === true ? 'Yes' : 'No';
		};
		vm.centerName = '';
		vm.students = [];
		vm.resources = {};
		vm.forests = [];
		vm.centerStudents = [];
		vm.selectedStudents = [];
		(vm.functionalAreaId = 0), (vm.StudentHourProjectId = 0);
		vm.StudentHourProject = {};
		vm.selectedStudentHour = {};
		vm.rsas = [];

		vm.totalPublicHours = function () {
			var totalHours = 0;
			vm.hours.forEach(function (item) {
				totalHours = totalHours + Number(item.Hours);
			});
			return totalHours;
		};
		vm.CalcFiscalYear = function () {
			var dToday = new Date();
			if (dToday.getMonth() > 8)
				//month starts at 0, so Oct is 9
				return dToday.getFullYear() + 1;
			else return dToday.getFullYear();
		};
		vm.ResName = function () {
			if (
				vm.selectedStudentHour.StudentResourceId > 0 &&
				vm.resources.ResourceList
			) {
				var item = vm.resources.ResourceList.find(
					(item) => item.ResourceId == vm.selectedStudentHour.StudentResourceId
				);
				return item.ResourceName;
			} else return '';
		};
		vm.FAName = function () {
			if (
				vm.StudentHourProject.FunctionalAreaId > 0 &&
				vm.resources.FunctionalAreaList
			) {
				var item = vm.resources.FunctionalAreaList.find(
					(item) =>
						item.FunctionalAreaId == vm.StudentHourProject.FunctionalAreaId
				);
				return item.MainArea + ': ' + item.SubArea;
			} else return '';
		};
		vm.showPartnerOrgOther = function (resource) {
			return resource !== undefined && resource === 327;
		};

		vm.handleChange = function handleChange(e) {
			vm.StudentHourProject.ProjectVerified = false;
		};

		$scope.subscribe(
			events.message._GET_CENTER_HOURS_LIST_COMPLETE_,
			onGetJcCenterHoursComplete
		);
		$scope.subscribe(
			events.message._GET_CENTER_HOURS_LIST_FAILED_,
			onCreateNewStudentHourProject
		);
		$scope.subscribe(
			events.message._SAVE_STUDENT_HOUR_COMPLETE_,
			onSaveHourComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_LIST_COMPLETE_,
			onGetStudentsComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_RESOURCES_LIST_COMPLETE_,
			onGetStudentResourcesComplete
		);
		$scope.subscribe(
			events.message._DELETE_STUDENT_HOUR_COMPLETE_,
			onDeleteFireHourComplete
		);
		$scope.subscribe(
			events.message._GET_JCCENTER_LIST_COMPLETE_,
			onGetCentersComplete
		);
		$scope.subscribe(
			events.message._GET_FOREST_LIST_COMPLETE_,
			onGetForestsComplete
		);

		$scope.subscribe(
			events.message._GET_FOREST_PROJECT_FAILED,
			onGetForestProjectFailed
		);
		$scope.subscribe(
			events.message._GET_FOREST_PROJECT_COMPLETE_,
			onGetForestProjectComplete
		);

		$scope.subscribe(
			events.message._SAVE_FOREST_PROJECT_FAILED,
			onSaveForestProjectFailed
		);
		$scope.subscribe(
			events.message._SAVE_FOREST_PROJECT_COMPLETE_,
			onSaveForestProjectComplete
		);

		$scope.subscribe(events.message._GET_RSA_LIST_COMPLETE_, onGetRSAsComplete);
		function onGetRSAsComplete(results) {
			vm.rsas = results;
		}

		vm.createNewForestProject = function () {
			vm.StudentHourProject = {};
			vm.StudentHourProject.CenterId = vm.centerId;
			vm.StudentHourProject.StudentHourProjectId = 0;
			vm.StudentHourProject.CalendarYear = vm.CalcFiscalYear();
			vm.hours = [];
		};

		activate();

		function activate() {
			if (
				authentication.userName === null ||
				authentication.userName === undefined ||
				!authentication.isAuth
			) {
				$scope.$state.go('login');
			}
			if ($rootScope.$stateParams.id === null) {
				$scope.$state.go('forestServices');
			}
			var id = $rootScope.$stateParams.id;
			var centerId = $rootScope.$stateParams.cid;
			vm.StudentHourProjectId = id;
			vm.centerId = centerId;

			if (id == 0) {
				vm.createNewForestProject();

				$scope.publish(events.message._GET_JCCENTER_LIST_, []);
				$scope.publish(events.message._GET_RSA_LIST_, []);
				$scope.publish(events.message._GET_STUDENT_LIST_, [true, vm.centerId]);
				$scope.publish(events.message._GET_STUDENT_RESOURCES_LIST_, []);
				//$scope.publish(events.message._GET_FOREST_PROJECT_, [id]);
				//$scope.publish(events.message._GET_CENTER_HOURS_LIST_, [id]);
				$scope.publish(events.message._GET_FOREST_LIST_, []);
			} else {
				$scope.publish(events.message._GET_JCCENTER_LIST_, []);
				$scope.publish(events.message._GET_RSA_LIST_, []);
				$scope.publish(events.message._GET_STUDENT_LIST_, [true, vm.centerId]);
				$scope.publish(events.message._GET_STUDENT_RESOURCES_LIST_, []);
				$scope.publish(events.message._GET_FOREST_PROJECT_, [id]);
				$scope.publish(events.message._GET_CENTER_HOURS_LIST_, [id]);
				$scope.publish(events.message._GET_FOREST_LIST_, []);
			}
		}

		function onGetForestsComplete(results) {
			vm.forests = results;
		}
		function onGetCentersComplete(results) {
			if (results && results.length) {
				var match = results.filter(function (item) {
					return Number(item.CenterId) === Number(vm.centerId);
				})[0];
				if (match) {
					vm.centerName = match.JCCCC;
				}
			}
			if (vm.userJCCCC !== 29) {
				vm.centerId = vm.userJCCCC;
			} else if (
				$rootScope.$stateParams.id !== null &&
				$rootScope.$stateParams.id !== undefined
			) {
				if (vm.userJCCCC !== 29) {
					vm.centerId = vm.userJCCCC;
				} else {
					vm.centerId = $rootScope.$stateParams.id;
				}
			}
		}

		vm.cancelForestProject = function (id) {
			if (vm.StudentHourProjectId) {
				$scope.publish(events.message._GET_FOREST_PROJECT_, [
					vm.StudentHourProjectId,
				]);
				$scope.publish(events.message._GET_CENTER_HOURS_LIST_, [
					vm.StudentHourProjectId,
				]);
			} else {
				vm.createNewForestProject();
			}
		};

		vm.canSaveForestProject = function () {
			if (
				vm.StudentHourProject.PartnerOrganizationId === 327 &&
				!vm.StudentHourProject.PartnerOrg
			) {
				return false;
			}

			// 				vm.StudentHourProject.CalendarYear > 2000 &&

			return (
				vm.StudentHourProject.CenterId > 0 &&
				vm.StudentHourProject.FunctionalAreaId &&
				vm.StudentHourProject.StudentResourceId &&
				vm.StudentHourProject.ProjectName !== undefined &&
				vm.StudentHourProject.ProjectName !== '' &&
				vm.StudentHourProject.ProjectSite !== undefined &&
				vm.StudentHourProject.ProjectSite !== '' &&
				vm.StudentHourProject.Comments !== undefined &&
				vm.StudentHourProject.Comments !== ''
			);
		};

		vm.saveForestProject = function () {
			if (vm.StudentHourProject.StudentHourProjectId > 0) {
				vm.StudentHourProject.LastModifiedBy = authentication.userName;
			} else {
				vm.StudentHourProject.Creator = authentication.userName;
				vm.StudentHourProject.CalendarYear = vm.CalcFiscalYear();
			}

			$scope.publish(events.message._SAVE_FOREST_PROJECT_, [
				vm.StudentHourProject,
			]);
		};

		function onGetForestProjectComplete(results) {
			vm.StudentHourProject = results;
			vm.StudentHourProjectId = vm.StudentHourProject.StudentHourProjectId;
			vm.centerId = vm.StudentHourProject.CenterId;
			getProjectDocuments(vm.StudentHourProjectId);
		}
		function onGetForestProjectFailed() {
			console.error('Forest Project not found.');
		}
		function onSaveForestProjectComplete(results) {
			vm.StudentHourProject = results;
			vm.StudentHourProjectId = results.StudentHourProjectId;

			if (vm.StudentHourProjectId > 0) {
				vm.selectedStudentHour = createStudentHourModel({
					StudentHourProjectId: vm.StudentHourProjectId,
					CenterId: vm.centerId,
					Active: 1,
					Deleted: 0,
					IsPLC: true,
					DispatchDate: '',
				});
				getProjectDocuments(vm.StudentHourProjectId);
			}
		}
		function onSaveForestProjectFailed() {
			console.error('Save Forest Project failed.');
		}

		vm.saveStudentHours = function (fh) {
			if (vm.StudentHourProjectId < 1) {
				alert(
					'Warning: Student hours will not save because the Project ID is invalid. Please re-select the project from the grid and re-enter the hours'
				);
			} else {
				fh.FunctionalAreaId = vm.StudentHourProject.FunctionalAreaId;
				fh.StudentResourceId = vm.StudentHourProject.StudentResourceId;
				if (fh.StudentHoursId > 0) {
					fh.LastModifiedBy = authentication.userName;
				} else {
					fh.Creator = authentication.userName;
				}
				fh.StudentHourProjectId = vm.StudentHourProjectId;
				vm.saveForestProject();

				for (const student of vm.selectedStudents) {
					const sf = structuredClone(fh);
					sf.StudentId = student.StudentId;
					$scope.publish(events.message._SAVE_STUDENT_HOUR_, [sf]);
				}

				vm.createNewStudentHour();
				vm.selectedStudents = [];

				$scope.publish(events.message._GET_JCCENTER_LIST_, []);
				$scope.publish(events.message._GET_STUDENT_LIST_, [true, vm.centerId]);
				$scope.publish(events.message._GET_STUDENT_RESOURCES_LIST_, []);
				$scope.publish(events.message._GET_CENTER_HOURS_LIST_, [
					vm.StudentHourProjectId,
				]);
				$scope.publish(events.message._GET_FOREST_LIST_, []);
			}
		};
		vm.deleteStudentHour = function (fh) {
			const confirmed = $window.confirm(
				'Are you sure you want to delete ' +
					fh.fullName() +
					"'s hours (" +
					fh.Hours +
					') from ' +
					vm.StudentHourProject.ProjectName +
					' for ' +
					vm.StudentHourProject.ProjectSite +
					'?'
			);
			if (confirmed) {
				$scope.publish(events.message._DELETE_STUDENT_HOUR_, [
					fh.StudentHoursId,
				]);
			}
		};

		vm.isStudentActive = function isStudentActive(fh) {
			return vm.students.some(function (st) {
				return st.StudentId === fh.StudentId;
			});
		};

		vm.editStudentHour = function editStudentHour(fh) {
			var student = vm.students.find(function (st) {
				return st.StudentId === fh.StudentId;
			});

			if (student) {
				vm.selectedStudents = [student];
			} else {
				alert('Student not found in active records. Aborting edit attempt.');
				return;
			}

			vm.selectedStudentHour = fh;
			if (vm.selectedStudentHour.DispatchDate) {
				vm.selectedStudentHour.DispatchDate = new Date(
					vm.selectedStudentHour.DispatchDate
				);
			}
			if (vm.selectedStudentHour.ReturnedDate) {
				vm.selectedStudentHour.ReturnedDate = new Date(
					vm.selectedStudentHour.ReturnedDate
				);
			}
			vm.selectedStudentHour.Hours = parseFloat(
				Math.round(vm.selectedStudentHour.Hours * 100) / 100
			);
			vm.selectedStudentHour.EstimatedHours = parseFloat(
				Math.round(vm.selectedStudentHour.EstimatedHours * 100) / 100
			);
		};

		vm.createNewStudentHour = function (id) {
			vm.selectedStudentHour = {
				StudentHourProjectId: vm.StudentHourProjectId,
				CenterId: vm.centerId,
				Active: 1,
				Deleted: 0,
				IsPLC: true,
				DispatchDate: '',
			};
		};

		function onGetStudentsComplete(results) {
			vm.students = results;
		}
		function onCreateNewStudentHourProject(a) {
			vm.selectedStudentHour = createStudentHourModel({
				StudentHourProjectId: vm.StudentHourProjectId,
				CenterId: vm.centerId,
				Active: 1,
				Deleted: 0,
				IsPLC: true,
				DispatchDate: '',
			});
		}
		function onGetJcCenterHoursComplete(results) {
			vm.hours = results;
			vm.selectedStudentHour = {
				StudentHourProjectId: vm.StudentHourProjectId,
				CenterId: vm.centerId,
				Active: 1,
				Deleted: 0,
				IsPLC: true,
				DispatchDate: '',
			};
		}
		function onSaveHourComplete() {
			$scope.publish(events.message._GET_CENTER_HOURS_LIST_, [
				vm.StudentHourProjectId,
			]);
		}

		function onDeleteFireHourComplete() {
			$scope.publish(events.message._GET_CENTER_HOURS_LIST_, [
				vm.StudentHourProjectId,
			]);
		}
		function onGetStudentResourcesComplete(results) {
			vm.resources = results;
		}

		function createStudentHourModel(src) {
			var self = {};
			src = src || {};
			self.StudentHoursId = src.StudentHoursId || 0;
			self.StudentId = src.StudentId;
			self.CenterId = src.CenterId || 0;
			self.IsPLC = src.IsPLC || true;

			self.ProjectName = src.ProjectName || '';
			self.PartnerOrg = src.PartnerOrg || '';
			self.ProjectSite = src.ProjectSite || '';

			self.Experience = src.Experience || '';
			self.StudentResourceId = src.StudentResourceId || 0;
			self.FocusArea = src.FocusArea || '';
			self.FunctionalAreaId = src.FunctionalAreaId || 0;
			self.FunctionalArea = src.FunctionalArea || '';
			self.DispatchDate = src.DispatchDate || '';
			self.ReturnedDate = src.ReturnedDate || '';
			self.CalendarYear = src.CalendarYear || vm.CalcFiscalYear();
			self.Hours = src.Hours || 0;
			self.FirstName = src.FirstName || '';
			self.MiddleInitial = src.MiddleInitial || '';
			self.LastName = src.LastName || '';
			self.Comments = src.Comments || '';
			self.Active = src.Active || 1;
			self.Deleted = src.Deleted || 0;
			self.Creator = src.Creator || '';
			self.LastModifiedBy = src.LastModifiedBy || '';
			self.CreatedDate = src.CreatedDate || new Date();
			self.CreatedDateString = src.CreatedDateString || '';
			self.CreatedBy = src.CreatedBy || '';
			self.LastUpdated = src.LastUpdated || new Date();
			self.LastUpdatedString = src.LastUpdatedString || '';
			self.LastUpdatedBy = src.LastUpdatedBy || '';
			self.UpdatingApp = src.UpdatingApp || '';

			return self;
		}

		//--------------------------------------------------------------
		function getProjectDocuments(projectId) {
			dataService
				.get(vm.baseUrl + 'getProjectFiles/' + projectId)
				.then(function (result) {
					vm.projectDocuments = result;
				});
		}

		function deleteDocumentFromServer(fileID, fileName) {
			//let base64Name = btoa(fileName);
			//dataService.get(vm.baseUrl + "DeleteProjectFile/" + fileID + "/" + base64Name).then(function (result) {
			dataService
				.get(vm.baseUrl + 'DeleteProjectFile/' + fileID)
				.then(function (result) {
					getProjectDocuments(vm.StudentHourProject.StudentHourProjectId);
					//vm.projectDocuments = result;
				});
		}

		vm.viewFile = function (fileName) {
			$window.open('Uploads/' + fileName);
		};

		vm.deleteFile = function (fileID, fileName) {
			if (confirm('Are you sure you want to delete this document') == true) {
				deleteDocumentFromServer(fileID, fileName);
			}
		};

		vm.doSaveFile = function () {
			doFileUploads(vm);
		};

		function doFileUploads(objProject) {
			let ProjectId = objProject.StudentHourProject.StudentHourProjectId;
			let LastUpdatedBy = objProject.StudentHourProject.LastUpdatedBy;

			if (document.getElementById('fileUploadDocs').value != '') {
				var file = document.getElementById('fileUploadDocs').files[0];
				var fileName = document.getElementById('fileUploadDocs').files[0].name;
				if ($window.FormData != null) {
					var data = new FormData();
					data.append('file', file);
					fileName = btoa(fileName);

					$.ajax({
						type: 'POST',
						url:
							objProject.baseUrl +
							'UploadFile/' +
							ProjectId +
							'/' +
							LastUpdatedBy +
							'/' +
							fileName,
						contentType: false,
						processData: false,
						data: data,
						success: function (result) {
							getProjectDocuments(
								objProject.StudentHourProject.StudentHourProjectId
							);
						},
						error: function (xhr, status, p3, p4) {
							var err = 'Error ' + ' ' + status + ' ' + p3 + ' ' + p4;
							if (xhr.responseText && xhr.responseText[0] == '{')
								err = JSON.parse(xhr.responseText).Message;
							console.error(err);
						},
					});
				}
				document.getElementById('fileUploadDocs').value = '';
				document.getElementById('btnSaveDoc').disabled = true;
			}
		}

		/**
		 *
		 * @param {string} column
		 */
		function setOrderBy(column) {
			vm.orderByReverse = vm.orderBy === column ? !vm.orderByReverse : false;
			vm.orderBy = column;
			sessionStorage.setItem('forestServiceOrderBy', column);
		}
	}
})();
